import Image from 'next/image'
import React from 'react'
import { BaseCard } from '../BaseCard'

export const FeaturedLearnMoreChallengeCard = () => {
    return (
        <BaseCard cardType="tall" boxShadow={false} onClick={null}>
            <Image
                alt={`Races Learn More card image`}
                src={'https://asset.yes.fit/homepage/learn-more-challenges.png'}
                layout="fill"
                objectFit="cover"
                className="bg-gray-800"
            />
            <div className="flex flex-col pt-8 z-10 absolute top-0 left-5">
                <p className="text-yf-salmon text-[10px] font-normal">FITNESS</p>
                <p className="mt-2 mb-1.5 text-white text-3xl font-medium leading-none tracking-wide">
                    Fitness
                    <br />
                    Challenges
                </p>
                <p className="text-sm font-normal text-white max-w-[180px]">
                    Got a day, a week, a month? Whatever time frame you have, we have a
                    challenge for you. Our in-house fitness team has crafted these
                    programs to get your body moving. If you are just starting out or a
                    seasoned fitness buff, our huge fitness collection is sure to get you
                    sweating.
                </p>
                <div>
                    <a
                        href="https://yesfit.app.link/app-store"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src="https://asset.yes.fit/homepage/AppStoreBadge.png"
                            className="mt-3 mb-1 max-h-[36px]"
                        />
                    </a>
                    <a
                        href="https://yesfit.app.link/google-play"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src="https://asset.yes.fit/homepage/PlaystoreBadge.png"
                            className="max-h-[36px]"
                        />
                    </a>
                </div>
            </div>
        </BaseCard>
    )
}
